import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.footer`
  background-color: #000000;
  padding: 30px 0;
  @media ${device.mobileS} {
    padding: 20px 16px;
  }
`;
export const ContainerInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const CopyRight = styled.p`
  font-size: 14px;
  line-height: 16px;
  font-weight: 900;
  color: #fff;
`;
export const Country = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  span {
    font-weight: 900;
  }
`;
